"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSwitchPaymentType = exports.PAYMENT_TYPES = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useGlobalState_1 = require("./useGlobalState");
var PAYMENT_TYPES;
(function (PAYMENT_TYPES) {
    PAYMENT_TYPES["DEPOSIT"] = "deposit";
    PAYMENT_TYPES["WITHDRAWAL"] = "withdrawal";
})(PAYMENT_TYPES = exports.PAYMENT_TYPES || (exports.PAYMENT_TYPES = {}));
var useSwitchPaymentType = function () {
    var _a = (0, useGlobalState_1.useGlobalState)(keys_1.globalStateKeys.PAYMENT_TYPE, PAYMENT_TYPES.DEPOSIT, false), state = _a.state, changeState = _a.changeState;
    return (0, react_1.useMemo)(function () { return ({
        paymentType: state,
        changePaymentType: changeState,
    }); }, [state, changeState]);
};
exports.useSwitchPaymentType = useSwitchPaymentType;
